import React from 'react';
import type { IContainerProps } from './Container.types';

export const Container: React.FC<IContainerProps> = ({
  children,
  variant = 'primary',
  padding = 'md',
  className = '',
  hide = false,
}: IContainerProps) => {

  const variantMapper = {
    "primary": "bg-bg-primary",
    "secondary": "bg-bg-secondary-hover",
    "tertiary": "bg-bg-tertiary",
    "brand": "bg-bg-brand-section",
    "transparent": "bg-transparent",
    "brand-primary": "bg-bg-brand-primary",
    "error-secondary": "bg-bg-error-secondary",
    "error-primary": "bg-bg-error-primary",
  };
  
  const paddingMapper = {
    "none": "p-bg-v2-none",
    "xs": "p-bg-v2-xs",
    "sm": "p-bg-v2-sm",
    "md": "p-bg-v2-md",
    "lg": "p-bg-v2-lg",
    "xl": "p-bg-v2-xl",
    "2xl": "p-bg-v2-2xl",
    "3xl": "p-bg-v2-3xl",
    "4xl": "p-bg-v2-4xl",
  };

  if (hide) {
    return null;
  }

  return (
    <div
      className={`${variantMapper[variant]} ${paddingMapper[padding]} ${className}`}
    >
      {children}
    </div>
  );
};

